/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const recordAppleSearchAdsV1BodySchema = z.object({
  deviceId: z.string(),
  attributionToken: z.string(),
  capturedAt: z.number(),
});

export type IRecordAppleSearchAdsV1Body = z.infer<typeof recordAppleSearchAdsV1BodySchema>;
